import {defineStore} from 'pinia'
import {ref, watchEffect} from 'vue'
interface Message {
  id: number
  text: string
  color?: string
  timeout?: number
  promise?: Promise<any>
}
let i = 0
const nextId = () => {
  if (i === Number.MAX_VALUE) {
    return (i = 0)
  }
  return i++
}
export const useMessageStore = defineStore('message', () => {
  const messages = ref<Message[]>([])
  const addMessage = (msg: Omit<Message, 'id'>) =>
    messages.value.push({
      ...msg,
      id: nextId(),
    })
  const removeMessage = (id: number) => {
    console.log('remove', id)
    messages.value = messages.value.filter(m => m.id !== id)
  }
  watchEffect(() => {
    console.log(messages.value.length)
  })
  return {messages, addMessage, removeMessage}
})
